// extracted by mini-css-extract-plugin
export default {"lineselect":"ToXixV","toolcolor__subtitle":"BnZQaQ","toolcolorSubtitle":"BnZQaQ"};